// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable___WgjD","large":"styles_large__316na"};